import { environment } from './../../../environment/environment';
import { CandidatService } from './../../core/services/candidat-service/candidat.service';
import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-profil-candidat',
  templateUrl: './profil-candidat.component.html',
  styleUrls: ['./profil-candidat.component.css'],
})
export class ProfilCandidatComponent {
  /* string */
  url: string = environment.baseUrl;
  /* number */
  idCandidat!: number;
  Candidate_info: any;
  /* number */
  totalItems!: number;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 5;
  loadSpinnerTable: boolean = false;
  pagination : boolean =false;

  loadSpinner: boolean = false;
  /* object */
  selectedCandidate!: any;
  /* array */

  test_file: any;
  show_cv: boolean = false;
  show_test: boolean = false;
  /* colors skills */
  colors = ['#FBF2E9', '#E8F6FC', '#FDEFEE', '#FFF3D7', '#FBF2E9'];
  urlimage: string = environment.baseUrlGalery;

  colorsHeader: string[] = [
    '#FBF2E9',
    '#E8F6FC',
    '#FDEFEE',
    '#FFF3D7',
    '#FBF2E9',
  ];
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private activatedRoute: ActivatedRoute,
    private candidatService: CandidatService,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe
  ) {}
  ngOnInit() {
    window.scrollTo(0, 0);
    this.getIdCandidat();
    this.getSkills();
  }

  howGlobalSpinner() {
    this.loadSpinner = true;
    this.spinner.show();
  }
  hideGlobalSpinner() {
    this.loadSpinner = false;
    this.spinner.hide();
  }
  /* get pagination items */
  getItems(event?: any) {
    if (event) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      (this.itemsPerPage = event.itemsPerPage),
        (this.currentPage = event.currentPage);
        if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){          this.pagination = true
          this.getSkills();
        }
    }
  }
  skills: any = [];
  /* get candidate skills */
  getSkills() {
    this.candidatService
      .getskillscandidat(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.skills = res.data.categoriesWithSubCategoriesAndSkills.slice(
            0,
            this.endIndex
          );
          this.totalItems = res.data.count;
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  /* get candidate id from route */
  getIdCandidat() {
    this.activatedRoute.paramMap.subscribe({
      next: (params: any) => {
        this.idCandidat = params.params['id'];
        this.getCandidateById();
      },
    });
  }
  /* get candidate by id */
  getCandidateById(): void {
    this.spinner.show();
    this.candidatService
      .getUserById(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.spinner.hide();
          this.selectedCandidate = res.data;
          this.selectedCandidate.current_country =
            !this.selectedCandidate.current_country ||
            this.selectedCandidate.current_country == 'null'
              ? ''
              : this.selectedCandidate.current_country;
          this.selectedCandidate.linkedin_link =
            !this.selectedCandidate.linkedin_link ||
            this.selectedCandidate.current_country == 'null'
              ? ''
              : this.selectedCandidate.linkedin_link;
          this.selectedCandidate.date_first_experience =
            !this.selectedCandidate.date_first_experience ||
            this.selectedCandidate.date_first_experience == 'null'
              ? ''
              : this.selectedCandidate.date_first_experience;
          this.selectedCandidate.desired_salary =
            !this.selectedCandidate.desired_salary ||
            this.selectedCandidate.desired_salary == 'null'
              ? ''
              : this.selectedCandidate.desired_salary;
          this.parseData('certificates');
          this.parseData('desired_contract');
          this.parseData('diplomas');
          this.parseData('mobility');
        },
        error: (err: Error) => {
          this.spinner.hide();
        },
      });
  }

  parseData(name: string) {
    if (
      typeof this.selectedCandidate[name] == 'string' &&
      this.selectedCandidate[name] == 'null'
    ) {
      this.selectedCandidate[name] = [];
    } else {
      this.selectedCandidate[name] = JSON.parse(this.selectedCandidate[name]);
    }
  }
  // /* open pdf in new target blank */
  OpenPDF(typeFile?: string) {
    this.spinner.show();
    const fileUrl = !typeFile
      ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
      : `${this.url}/api/ResponseCandidate/GetFile/${
          this.selectedCandidate.file_test.split('/')[1]
        }`;
    this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      this.spinner.hide();
      window.open(fileURL, '_blank');
    });
  }
  /* download file */
  downloadFile(typeFile?: string) {
    if (typeFile && typeFile != '')
      this.selectedCandidate.file_test =
        this.selectedCandidate.file_test.split('/')[1];
    this.spinner.show();
    const fileUrl = !typeFile
      ? `${this.url}/api/User/file/gallery_cvs/${this.selectedCandidate.cv}`
      : `${this.url}/api/ResponseCandidate/GetFile/${this.selectedCandidate.file_test}`;
    this.candidatService.downloadPDF(fileUrl).subscribe((blob) => {
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = !typeFile
        ? `${this.selectedCandidate.ID_user}_${
            this.selectedCandidate.first_name
          }_${
            this.selectedCandidate.last_name
          }_CV.${this.selectedCandidate!.cv.split('.').pop()}`
        : `${this.selectedCandidate.ID_user}_${
            this.selectedCandidate.first_name
          }_${
            this.selectedCandidate.last_name
          }_QCM.${this.selectedCandidate!.file_test.split('.').pop()}`;
      document.body.appendChild(a);
      a.click();
      this.spinner.hide();
    });
  }
  //////////////////////////////date de creation pour afficher dans la liste ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  formatDate(dateString: string | null): string {
    if (!dateString) {
      return ''; // Gérer le cas où la date est null ou undefined
    }

    const date = new Date(dateString);
    return this.datePipe.transform(date, 'yyyy-MM-dd') || ''; // Gérer le cas où la transformation échoue
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  openResultTest(): void {
    console.log(
      '%cdossier-compt.component.ts line:229 test_file',
      'color: #007acc;',
      this.test_file
    );

    this.candidatService
      .downloadPDFTest(this.test_file)
      .subscribe((blob: any) => {
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      });
  }
  downloadResultTest() {
    const link = document.createElement('a');
    link.href = this.test_file;
    link.download = 'downloaded_test.pdf';
    link.click();
  }
}
